import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "@/lib/api";
import { ArrowLeft, Play, Loader2 } from "lucide-react";

export default function ProductDemosPage() {
  const navigate = useNavigate();
  const [demos, setDemos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { API.get("/content/product-demos").then(r => setDemos(r.data || [])).catch(() => {}).finally(() => setLoading(false)); }, []);

  const demoItems = demos.filter(d => !d.product_code || d.product_code === "explore" ? false : true);

  const getYouTubeThumbnail = (url) => {
    if (!url) return null;
    const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([^?&]+)/);
    return match ? `https://img.youtube.com/vi/${match[1]}/mqdefault.jpg` : null;
  };

  const renderItems = (items) => {
    if (items.length === 0) return <p className="text-center text-gray-400 py-8 text-sm">No items available yet</p>;
    return (
      <div className="space-y-3">
        {items.map(item => {
          const thumb = getYouTubeThumbnail(item.media_url);
          return (
            <a key={item.id} href={item.media_url || "#"} target="_blank" rel="noopener noreferrer"
              className="block bg-white rounded-xl border overflow-hidden hover:border-[#008A99] hover:shadow-md transition-all" data-testid="demo-item">
              {thumb ? (
                <div className="relative w-full h-40 bg-gray-100">
                  <img src={thumb} alt={item.title} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center shadow-lg">
                      <Play className="w-6 h-6 text-white ml-0.5" fill="white" />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="w-full h-32 bg-gradient-to-br from-[#E0F4F5] to-[#F0F9FF] flex items-center justify-center">
                  <Play className="w-10 h-10 text-[#008A99]/30" />
                </div>
              )}
              <div className="p-3">
                <p className="font-semibold text-sm text-gray-900">{item.title}</p>
                {item.content && <p className="text-xs text-gray-500 mt-0.5">{item.content}</p>}
              </div>
            </a>
          );
        })}
      </div>
    );
  };

  return (
    <div className="space-y-4" data-testid="product-demos-page">
      <div className="flex items-center gap-3">
        <button onClick={() => navigate(-1)} className="p-1.5 rounded-lg hover:bg-gray-100"><ArrowLeft className="w-5 h-5" /></button>
        <h1 className="text-xl font-bold text-gray-900">Product Demo</h1>
      </div>
      {loading ? <div className="text-center py-12"><Loader2 className="w-6 h-6 animate-spin text-[#008A99] mx-auto" /></div> :
        renderItems(demoItems.length > 0 ? demoItems : demos)
      }
    </div>
  );
}
